(() => {
  if (window.asenmoCartFeedback) return;
  let revision = 0;
  window.asenmoCartFeedback = () => {
    if (document.documentElement.dataset.postAddAction !== 'message') return false;
    const notice = document.getElementById('CartAddedFeedback');
    if (!notice) return false;
    notice.hidden = false;
    // Keep focus at the shopper's purchase control. The live status announces success.
    const current = ++revision;
    const url = window.routes?.cart_url;
    if (url) Promise.resolve().then(() => fetch(`${url}?section_id=cart-icon-bubble`, { cache: 'no-store' }))
      .then(response => { if (response.ok === false) throw Error('Cart badge unavailable'); return response.text(); })
      .then(html => {
        if (current !== revision) return;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }).catch(() => {});
    return true;
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-close-cart-feedback]')) {
      const notice = document.getElementById('CartAddedFeedback');
      if (notice) notice.hidden = true;
    }
  });
})();
